/* @flow */

import $ from 'jquery';

const montarSelectTipoEmpresa = (selector: string, tiposEmpresa: Object[]) => {
    const tipoEmpresa = $(selector);
    tiposEmpresa.forEach((option) => {
        tipoEmpresa.append(new global.Option(
            option.nome,
            option.id,
            false,
            true,
        ))
            .trigger('change');
    });
};

export default montarSelectTipoEmpresa;
